<input type="file" (change)="onFileSelect($event)" />
